import { Tooltip, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserCheck } from "@fortawesome/pro-solid-svg-icons"

import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"

import type { MeetingArrivals } from "./helpers"

const useStyles = makeStyles()((theme) => ({
    badge: {
        display: "inline-flex",
        alignItems: "center",
        gap: ".375rem",
        padding: ".25rem .625rem",
        borderRadius: "6.25rem",
        fontWeight: theme.typography.fontWeightBold,
        whiteSpace: "nowrap",
    },
    icon: {
        fontSize: ".75rem",
    },
    none: {
        backgroundColor: theme.palette.tailwind.slate[100],
        color: theme.palette.tailwind.slate[500],
    },
    partial: {
        backgroundColor: theme.palette.tailwind.amber[50],
        color: theme.palette.tailwind.amber[700],
    },
    full: {
        backgroundColor: theme.palette.tailwind.teal[50],
        color: theme.palette.tailwind.teal[700],
    },
}))

type Props = Readonly<{
    arrivals: MeetingArrivals
}>

export function MeetingArrivalsBadge({ arrivals }: Props) {
    const { classes, cx } = useStyles()
    const { arrived, total } = arrivals
    const stateClass = arrived === 0 ? classes.none : arrived >= total ? classes.full : classes.partial

    return (
        <LocalizedStrict
            id="service-center-reports-dashboard-meetings-list-row-arrivals-tooltip"
            attrs={{ title: true }}
        >
            <Tooltip title="Checked in">
                <Typography variant="body2" component="span" className={cx(classes.badge, stateClass)}>
                    <FontAwesomeIcon icon={faUserCheck} className={classes.icon} />
                    {arrived}/{total}
                </Typography>
            </Tooltip>
        </LocalizedStrict>
    )
}
